/**
 * Extracts nodes from waypoints by grouping them by their parentNode.
 * Each node contains the type, feature, and indices of waypoints that belong to it.
 */
export function extractNodes(waypoints) {
  const nodeMap = new Map();
  let nodeCounter = 0; // Counter for unique IDs

  waypoints.forEach((waypoint, index) => {
    const nodeKey = waypoint.parentNode || 'unknown';

    if (!nodeMap.has(nodeKey)) {
      // Create a stable ID for this node based on the parentNode element
      // Use name attribute if available, otherwise use a counter for uniqueness
      let stableId;
      if (nodeKey && nodeKey.getAttribute) {
        const name = nodeKey.getAttribute('name');
        if (name) {
          stableId = `node-${name}`;
        } else {
          stableId = `node-${nodeCounter++}`;
        }
      } else {
        stableId = `node-unknown-${nodeCounter++}`;
      }

      nodeMap.set(nodeKey, {
        type: waypoint.nodeType || 'Unknown',
        feature: waypoint.feature || 'default',
        indices: [],
        strategyClass: waypoint.strategyClass,
        _stableId: stableId,
        _parentNode: nodeKey // Keep reference to parent for reordering
      });
    }

    nodeMap.get(nodeKey).indices.push(index);
  });

  return Array.from(nodeMap.values());
}
